import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  paymentsLoading: false,
  autoUpdateLoading: false,
  error: null,
  payments: [],
  storePayment: null,
  storeAutoUpdate: null,
  autoUpdateInfo: null,
};
const branchSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    loadPaymentsRequested(state, action: PayloadAction<{}>) {
      state.paymentsLoading = true;
      state.error = null;
    },
    loadPaymentsSuccess(state, action: any) {
      state.paymentsLoading = false;
      state.error = null;
      state.payments = action.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.perPage,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadPaymentsFail(state, action: PayloadAction<{}>) {
      state.paymentsLoading = false;
      state.error = action.payload;
    },

    loadPaymentBillRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadPaymentBillSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.paymentBill = action.payload?.result;
    },
    loadPaymentBillFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storePaymentRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storePaymentSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storePayment = action.payload;
    },
    storePaymentFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadBillInfoRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadBillInfoSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.billInfo = action.payload?.result;
    },
    loadBillInfoFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeAutoUpdatePaymentRequested(state, action: PayloadAction<{}>) {
      state.autoUpdateLoading = true;
      state.error = null;
    },
    storeAutoUpdatePaymentSuccess(state, action: any) {
      state.autoUpdateLoading = false;
      state.error = null;
      state.storeAutoUpdate = action.payload?.result;
    },
    storeAutoUpdatePaymentFail(state, action: PayloadAction<{}>) {
      state.autoUpdateLoading = false;
      state.error = action.payload;
    },
    loadAutoUpdatePaymentRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadAutoUpdatePaymentSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.autoUpdateInfo = action.payload?.result;
    },
    loadAutoUpdatePaymentFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadBillInfoByDateRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadBillInfoByDateSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.billInfoByDate = action.payload?.result;
    },
    loadBillInfoByDateFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadPaymentsRequested,
  loadPaymentsSuccess,
  loadPaymentsFail,
  loadPaymentBillRequested,
  loadPaymentBillSuccess,
  loadPaymentBillFail,
  storePaymentRequested,
  storePaymentSuccess,
  storePaymentFail,
  loadBillInfoRequested,
  loadBillInfoSuccess,
  loadBillInfoFail,
  storeAutoUpdatePaymentRequested,
  storeAutoUpdatePaymentSuccess,
  storeAutoUpdatePaymentFail,
  loadAutoUpdatePaymentRequested,
  loadAutoUpdatePaymentSuccess,
  loadAutoUpdatePaymentFail,
  loadBillInfoByDateRequested,
  loadBillInfoByDateSuccess,
  loadBillInfoByDateFail,
} = branchSlice.actions;

export default branchSlice.reducer;
